import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './App.css'
import { initializeActivityLogRequestTracking } from "./lib/activityLogQueryParam";
const root = ReactDOM.createRoot(document.getElementById('root'));

initializeActivityLogRequestTracking();

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
